import React, { useState, useCallback, useEffect } from 'react'
import { Card, List, Button, Modal, Result, Spin, Empty, Typography, Tag, Row, Col, Divider } from 'antd'
import { QrcodeOutlined, CameraOutlined, CheckCircleOutlined } from '@ant-design/icons'
import taskService from '../../../services/tasks/taskService'
import { showSuccessToast, showErrorToast } from '../../../helpers/toast'
import SimpleHeader from '../../../helpers/cards-helper/SimpleHeader'
import { BRAND, BRAND_DIVIDER } from '../constants'

const { Text } = Typography

let QrReader = null

export default function QRScanner() {
  const [tasks, setTasks] = useState([])
  const [loading, setLoading] = useState(false)
  const [scanning, setScanning] = useState(false)
  const [scanResult, setScanResult] = useState(null)
  const [scanLoading, setScanLoading] = useState(false)
  const [qrReaderLoaded, setQrReaderLoaded] = useState(false)

  useEffect(() => {
    fetchTasks()
    import('react-qr-reader').then((mod) => {
      QrReader = mod.default || mod
      setQrReaderLoaded(true)
    }).catch(() => {})
  }, [])

  const fetchTasks = async () => {
    setLoading(true)
    try {
      const response = await taskService.getQrTasks()
      setTasks(response.data.results || response.data || [])
    } catch {
      setTasks([])
    } finally {
      setLoading(false)
    }
  }

  const handleScan = useCallback(async (data) => {
    if (!data || scanLoading) return
    setScanLoading(true)
    try {
      await taskService.scanQrCode(data)
      setScanResult('success')
      showSuccessToast('QR kodi u skanua me sukses!')
    } catch (error) {
      if (error.response?.status === 409) {
        setScanResult('already')
        showErrorToast('Ky QR kod eshte skanuar me pare.')
      } else {
        setScanResult('error')
      }
    } finally {
      setScanLoading(false)
    }
  }, [scanLoading])

  const handleError = useCallback(() => {
    showErrorToast('Gabim ne hapjen e kameres.')
  }, [])

  return (
    <Row gutter={24} className="page-content">
      <Col span={24}>
        <SimpleHeader title="Skanimi QR" subtitle="QR" />
      </Col>

      <Col span={24} className="mt-2">
        <Card>
          <Button
            type="primary"
            icon={<CameraOutlined />}
            onClick={() => { setScanning(true); setScanResult(null) }}
            style={{ marginBottom: 16, backgroundColor: BRAND, borderColor: BRAND }}
            aria-label="Hap skanerin"
          >
            Skano QR Kod
          </Button>

          <Divider orientation="left" style={{ borderTopColor: BRAND_DIVIDER }} className="m-0">
            <h4 className="m-0" style={{ color: BRAND }}>Detyrat me QR kod</h4>
          </Divider>

          <Spin spinning={loading}>
            {tasks.length === 0 && !loading ? (
              <div style={{ padding: 40 }}>
                <Empty description="Nuk ka detyra me QR kod" />
              </div>
            ) : (
              <List
                dataSource={tasks}
                renderItem={(task) => (
                  <List.Item>
                    <List.Item.Meta
                      avatar={<QrcodeOutlined style={{ fontSize: 24, color: BRAND }} />}
                      title={<Text strong>{task.name}</Text>}
                      description={
                        <span>
                          {task.description?.substring(0, 100)}
                          {task.is_scanned && (
                            <Tag color="green" style={{ marginLeft: 8 }}>
                              <CheckCircleOutlined /> Skanuar
                            </Tag>
                          )}
                        </span>
                      }
                    />
                  </List.Item>
                )}
              />
            )}
          </Spin>
        </Card>
      </Col>

      <Modal
        title={<span style={{ color: BRAND }}>Skano QR Kod</span>}
        visible={scanning}
        onCancel={() => setScanning(false)}
        footer={null}
        width={500}
        destroyOnClose
        centered
      >
        {scanResult ? (
          <Result
            status={scanResult === 'success' ? 'success' : scanResult === 'already' ? 'warning' : 'error'}
            title={
              scanResult === 'success'
                ? 'Skanuar me sukses!'
                : scanResult === 'already'
                ? 'Tashme i skanuar'
                : 'Gabim ne skanim'
            }
            extra={
              <Button
                type="primary"
                onClick={() => setScanResult(null)}
                style={{ backgroundColor: BRAND, borderColor: BRAND }}
              >
                Skano perseri
              </Button>
            }
          />
        ) : qrReaderLoaded && QrReader ? (
          <div>
            <QrReader
              delay={300}
              onError={handleError}
              onScan={handleScan}
              style={{ width: '100%' }}
            />
            {scanLoading && (
              <div style={{ textAlign: 'center', marginTop: 16 }}>
                <Spin tip="Duke procesuar..." />
              </div>
            )}
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: 40 }}>
            <Spin tip="Duke ngarkuar skanerin..." />
          </div>
        )}
      </Modal>
    </Row>
  )
}
